import cookieLib from 'js-cookie';

const cookie = cookieLib.withConverter({
  // Override to prevent the default read/write encoding
  read: value => value,
  write: value => value
});

export const UTM_PARAM_COOKIE_NAME = 'we_search_params';

export function setCookieContainingUtmParamsIfTheyExist() {
  const { searchParams } = new URL(window.location.href);
  const utmParamsCookieObject = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].reduce(
    (memo, utm_param) => (searchParams.has(utm_param) ? { ...memo, [utm_param]: searchParams.get(utm_param) } : memo),
    {}
  );
  const utmParamsCookieValue = JSON.stringify(utmParamsCookieObject);

  if (utmParamsCookieValue !== '{}') {
    const encodedUtmParamsCookieValue = encodeURIComponent(utmParamsCookieValue);
    cookie.set(UTM_PARAM_COOKIE_NAME, encodedUtmParamsCookieValue);
  }
}

export function getUtmParamsFromCookie() {
  const utmParamsCookieValue = cookie.get(UTM_PARAM_COOKIE_NAME);
  let utmParams = {};
  if (utmParamsCookieValue) {
    try {
      const decodedUtmParamsCookieValue = decodeURIComponent(utmParamsCookieValue);
      utmParams = JSON.parse(decodedUtmParamsCookieValue || '{}');
    } catch (err) {
      console.log('error parsing UTM params cookie', err.message); // eslint-disable-line no-console
    }
  }

  return utmParams;
}
